import { render, staticRenderFns } from "./Pre_footer.vue?vue&type=template&id=ff327196&scoped=true&"
import script from "./Pre_footer.vue?vue&type=script&lang=ts&"
export * from "./Pre_footer.vue?vue&type=script&lang=ts&"
import style0 from "./Pre_footer.vue?vue&type=style&index=0&id=ff327196&prod&lang=css&"
import style1 from "./Pre_footer.vue?vue&type=style&index=1&id=ff327196&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff327196",
  null
  
)

export default component.exports